
import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { PERMISSION } from '@/permissions';
import ExpansionPanel from '@/components/shared/suites/panels/ExpansionPanel.vue';
import ModifyFee from '@/components/orders/cart/ModifyFee.vue';
import IconButton from '@/components/shared/suites/IconButton.vue';

const namespace = 'orders';

@Component<OrderCartPricing>({
	components: {
		ModifyFee,
		ExpansionPanel,
		IconButton
	}
})
export default class OrderCartPricing extends Vue {
	@Getter('getSubtotal', { namespace }) private subtotal!: string;
	@Getter('getPromoDiscount', { namespace }) private promoDiscount!: string;
	@Getter('getMemberDiscount', { namespace }) private memberDiscount!: string;
	@Getter('getServiceCharge', { namespace }) private serviceCharge!: string | null;
	@Getter('getServiceChargeLabel', { namespace }) private serviceChargeLabel!: string;
	@Getter('getDeliveryCharge', { namespace }) private deliveryCharge!: string | null;
	@Getter('getTaxes', { namespace }) private taxes!: string;
	@Getter('getTaxBrackets', { namespace }) private taxBrackets!: any;
	@Getter('getVoucherAmount', { namespace }) private voucherAmount!: string;
	@Getter('getTotal', { namespace }) private total!: string;
	@Getter('getTip', { namespace }) private tip!: string;
	@Getter('getTotalWithTip', { namespace }) private totalWithTip!: string;
	@Getter('getOrderType', { namespace }) private orderType!: string;
	@Getter('getCosts', { namespace }) private costs!: Costs;
	@Getter('isCateringRestaurant', { namespace: 'auth' }) private isCateringRestaurant!: boolean;
	@Getter('hasPermission', { namespace: 'auth' }) private hasPermission!: (permission: PERMISSION) => boolean;

	private modifyingFee: Record<FeeType, boolean> = { serviceCharge: false, deliveryCharge: false };
	@Getter('isTaxInclusiveWithInfo', { namespace: 'auth' }) private isTaxInclusiveWithInfo!: boolean;

	private get taxesLabel(): string {
		if(this.taxBrackets && this.taxBrackets['GST'] && this.taxBrackets['PST']) {
			return `${this.$t('orders.cart.pricing.taxes')} (${this.$t('orders.cart.pricing.gst')} / ${this.$t('orders.cart.pricing.pst')})`;
		}
		return this.$t('orders.cart.pricing.taxes');
	}

	private get hasTip(): boolean {
		return Number(this.tip) > 0;
	}

	private get hasFeeModificationAccess(): boolean {
		return this.isCateringRestaurant && this.orderType === 'generic-catering' && this.hasPermission(PERMISSION.ORDER_MODIFY);
	}
}
